import React from 'react';
import ReactDOM from 'react-dom/client';

import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from './context/ContextApp';

import App from './App';

import 'normalize.css';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <AppProvider>
        
        <App />
        
      </AppProvider>
    </React.StrictMode>
  </BrowserRouter>
);

